module.exports = __webpack_public_path__ + "static/media/Group 2312.314c5163.svg";